import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { Homehealthagency } from './home-health-agency.model';

@Injectable({
  providedIn: 'root'
})
export class HomehealthagencyService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  SaveOrUpdateHHA(saveList: Homehealthagency): Observable<any> {
    let url = "api/HHAgency/SaveHHAgency";
    return this.http.post(url, saveList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



  DeleteHHA(Id: any): Observable<any> {
    let url = "api/HHAgency/DeleteHHAgency?";
    return this.http.delete(url+Id, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getHHAlist(): Observable<any> {
    var url = "api/HHAgency/getFMSAgencyDropDownList?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(map(data => data.body),
        catchError(this.errorService.handleError));
}
  
}
